import React from 'react'
import { Accordion, AccordionSummary, AccordionDetails, Typography, Box, FormHelperText } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CommonQuillEditor from 'common/editor';
import EditableAccordionHeader from '../components/EditableAccordionHeader';
function ContentSection({
  contentOpen,
  setContentOpen,
  formData,
  setFormData,
  errors,
  setErrors,
  // Heading editing props
  sectionHeading,
  isEditingHeading,
  tempHeadingValue,
  setTempHeadingValue,
  onEditHeading,
  onSaveHeading,
  onCancelHeading,
}) {
  return (
    <Accordion expanded={contentOpen} onChange={() => setContentOpen(!contentOpen)}>
    <AccordionSummary
      expandIcon={<ExpandMoreIcon />}
      aria-controls="paneltopesection-content"
      id="paneltopesection-header"
    >
      <EditableAccordionHeader
        sectionKey="contentSection"
        heading={sectionHeading}
        isEditing={isEditingHeading}
        tempValue={tempHeadingValue}
        setTempValue={setTempHeadingValue}
        onEdit={onEditHeading}
        onSave={onSaveHeading}
        onCancel={onCancelHeading}
      />
    </AccordionSummary>
    <AccordionDetails>
      <Box width="100%" className="faq-sec-rep">
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          alignItems={"flex-start"}
          className="mb-3"
        >
          <Box
            width={"100%"}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            mb={1}
          >
            <Typography
              variant="body2"
              fontWeight="medium"
              color="#9A9AAF"
              name="stateParagraph"
              style={{ fontSize: "14px" }}
            >
              Paragraph
            </Typography>
          </Box>
          <Box width={"100%"} name={``}>
            <CommonQuillEditor
              allowHeading={false}
              // allowImage={false}
              // value={faq?.question || ''}
              // onChange={(value) => handleChangeFAQ(value, 'question', idx)}
              value={formData.stateParagraph}
              // error={}
              // helperText
              onChange={(value) => {
                setErrors((prev) => ({ ...prev, stateParagraph: "" }));
                setFormData((prev) => ({
                  ...prev,
                  stateParagraph: value,
                }));
              }}
            />
            {!!errors?.stateParagraph && (
              <FormHelperText error>{errors?.stateParagraph}</FormHelperText>
            )}

            {/* {!!errors[`faq_${item.faqId}_question`] && (
          <FormHelperText error>{errors[`faq_${item.faqId}_question`]}</FormHelperText>
        )} */}
          </Box>
        </Box>
      </Box>
    </AccordionDetails>
  </Accordion>
  )
}

export default ContentSection